<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .overflow-icons {
    display: grid;

    grid-template-columns: repeat(3, 1fr);
    &[data-count="1"] {
      grid-template-columns: repeat(1, 1fr);
    }
    &[data-count="2"] {
      grid-template-columns: repeat(2, 1fr);
    }
    gap: utils.in_rem(14px);
    padding: utils.in_rem(14px);

    border-radius: 20px;
    border: 1.5px solid #f7f7f7;
    background: white;
    box-shadow: 0px 4px 20px 0px #00000014;
  }
</style>

<script>
  // Stores
  import { matchedLinksWithVisibilityStore } from "./stores";
  // Components
  import ProfileCardOverflow from "../ProfileCardOverflow.svelte";
  import Links from "./Links.svelte";

  // Count number of links to display in the FloatingUI.
  // count should initialize to 0 every time todosModalItemStore changes.
  $: count = Object.values($matchedLinksWithVisibilityStore).filter(
    (x) => !x.show
  ).length;
</script>

<ProfileCardOverflow {count}>
  <div slot="hidden-items" class="overflow-icons" data-count={count}>
    <Links showHidden={true} />
  </div>
</ProfileCardOverflow>
